<div class="container">
    <div class="row me-landing-page-how-it-works">
        <div tabindex="0" class="col-xs-12 me-landing-page-how-it-works__title">
            {{data.headline}}
        </div>
        <div class="col-md-6 col-xs-12 carousel-container">
            <a *ngIf="!hidePrev" class="carousel-nav__left" (click)="owlCar.prev()">
                <i class="far fa-chevron-left"></i>
            </a>
            <owl-carousel-o [options]="customOptions" (changed)="getDataCarousel($event)" #owlCar>
                <ng-container *ngFor="let galery of data['gallery']">
                  <ng-template carouselSlide>
                    <img class="carousel-img" [src]="galery['filename']">
                  </ng-template>
                </ng-container>
            </owl-carousel-o>
            <a *ngIf="!hideNext" class="carousel-nav__right" (click)="owlCar.next()">
                <i class="far fa-chevron-right"></i>
            </a>
        </div>
        <div class="col-md-6 col-xs-12">
            <div tabindex="0" class="landing-page-step" *ngFor="let step of data['steps']">
                <div class="landing-page-step__img">
                    <img src="{{step['icon']['filename']}}">
                </div>
                <div class="landing-page-step__content">
                    <div class="landing-page-step__header">
                        {{step['title']}}
                        <div class="landing-page-step__header__money">
                            <span class="landing-page-step__header__money__discount">{{step['price']}}</span>
                            <span class="landing-page-step__header__money__normal">{{step['oldPrice']}}</span>
                        </div>
                    </div>
                    <div class="landing-page-step__body" [innerHTML]="step.benefits | storyblokRichtext">
                    </div>
                    <div *ngIf="step.info" class="landing-page-step__info">
                        <i class="fal fa-info-circle icon"></i>
                        <span class="text">{{step.info}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>